/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Control_Hero_EyebrowInputs */

const en_control_hero_eyebrow = /** @type {(inputs: Control_Hero_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A field guide for the unfamiliar`)
};

const zh_control_hero_eyebrow = /** @type {(inputs: Control_Hero_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`《控制: 共振》工具与攻略`)
};

/**
* | output |
* | --- |
* | "A field guide for the unfamiliar" |
*
* @param {Control_Hero_EyebrowInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const control_hero_eyebrow = /** @type {((inputs?: Control_Hero_EyebrowInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Control_Hero_EyebrowInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_control_hero_eyebrow(inputs)
	return zh_control_hero_eyebrow(inputs)
});
export { control_hero_eyebrow as "control.hero.eyebrow" }